// ═══════════════════════════════════════════════════════════════
// bookingApi.js — Client /api/booking/*
// ═══════════════════════════════════════════════════════════════

const getToken = () => localStorage.getItem('oracle_token');

export class BookingApiError extends Error {
  constructor(status, message) {
    super(message || `HTTP ${status}`);
    this.name = 'BookingApiError';
    this.status = status;
  }
}

async function request(path, { method = 'GET', body = null } = {}) {
  const res = await fetch(path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new BookingApiError(res.status, data.error || data.message || `HTTP ${res.status}`);
  }
  return data;
}

export const getMyHost = () => request('/api/booking/me/host');
export const updateMyHost = (patch) => request('/api/booking/me/host', { method: 'PUT', body: patch });
export const upsertOfferings = (offerings) =>
  request('/api/booking/me/offerings', { method: 'PUT', body: { offerings } });
export const replaceAvailabilityRules = (rules) =>
  request('/api/booking/me/availability-rules', { method: 'PUT', body: { rules } });
export const listAppointments = (status) =>
  request(`/api/booking/me/appointments${status ? `?status=${encodeURIComponent(status)}` : ''}`);
export const getAppointmentRelation = (id) =>
  request(`/api/booking/me/appointments/${id}/relation`);
export const confirmAppointment = (id) =>
  request(`/api/booking/me/appointments/${id}/confirm`, { method: 'POST', body: {} });
export const declineAppointment = (id, reason) =>
  request(`/api/booking/me/appointments/${id}/decline`, { method: 'POST', body: { reason } });
export const cancelAppointment = (id) =>
  request(`/api/booking/me/appointments/${id}/cancel`, { method: 'POST', body: {} });
export const markDoneAppointment = (id) =>
  request(`/api/booking/me/appointments/${id}/done`, { method: 'POST', body: {} });
export const decideRelationProposal = (relationId, proposalId, decision) =>
  request(`/api/booking/me/relations/${relationId}/proposals/${proposalId}/decide`, {
    method: 'POST',
    body: { decision },
  });
export const getMyAvailability = (offeringCode, { from, to } = {}) => {
  const params = new URLSearchParams({ offering: offeringCode });
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  return request(`/api/booking/me/availability?${params.toString()}`);
};
